import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'

export class TypeformResponseDefinitionFieldChoice extends BaseModel<TypeformResponseDefinitionFieldChoice> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public choiceId: string,
        public choiceLabel: string,
    ) { super(null) }

    toRequestData(): any {
        return {
            choiceId: this.choiceId,
            choiceLabel: this.choiceLabel,
        }
    }

    static fromData(data: any): TypeformResponseDefinitionFieldChoice {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseDefinitionFieldChoice) {
            return data
        }

        return new TypeformResponseDefinitionFieldChoice(
            data.choiceId,
            data.choiceLabel,
        )
    }
}
